import './styles.scss'

const CLASS_NAME = 'logo'

const Logo = () => {
    return <div className={`${CLASS_NAME} flex-center`}>
        <div className={`${CLASS_NAME}-image`}></div>
        <div className={`${CLASS_NAME}-text`}>
            <p className={`${CLASS_NAME}-heading`}>Keyes2Safety</p>
            <p className={`${CLASS_NAME}-sub-heading`}>Construction (SSHO) Safety</p>
            <span>Est. 2005</span>
        </div>
    </div>
}

export default Logo;